/* ROLL 3D configurator — Shopify theme asset
   Requires window.ROLL_CFG (injected by the product-page Custom Liquid block)
   and roll-three.js in the theme assets folder. */
(function(){
"use strict";
if(!window.ROLL_CFG) return;
var CFG=window.ROLL_CFG;

/* ---------- asset URLs (Shopify Files) ---------- */
var CDN="https://cdn.shopify.com/s/files/1/0834/0675/0031/files/";
var A={
  closed100:CDN+"roll-closed-100.file?v=1784713631", closed150:CDN+"roll-closed-150.file?v=1784713691",
  open100:CDN+"roll-open-100.file?v=1784713632",     open150:CDN+"roll-open-150.file?v=1784713709",
  oakB:CDN+"veneer-oak-color-2k.jpg?v=1784713495",   oakN:CDN+"veneer-oak-normal-1k.jpg?v=1784713494",
  oakR:CDN+"veneer-oak-rough-512.jpg?v=1784713493",  walB:CDN+"veneer-walnut-color-2k.jpg?v=1784713495",
  walN:CDN+"veneer-walnut-normal-1k.jpg?v=1784713493",walR:CDN+"veneer-walnut-rough-512.jpg?v=1784713493",
  melClosed:CDN+"melamine-walnut-closed-2k.jpg?v=1784713495",
  melOpen:CDN+"melamine-walnut-open-1k.jpg?v=1784713494",
  card:CDN+"cardboard-neutral.jpg?v=1784713493"
};

/* ---------- option model: state -> Shopify option value names ---------- */
var FINISH={
  paint:[{id:"white",name:"White",hex:"#8e9093",sw:"#E8E6E1"},
         {id:"grey",name:"Grey",hex:"#45474a",sw:"#45474A"},
         {id:"charcoal",name:"Charcoal",hex:"#1c1d1f",sw:"#1C1D1F"}],
  melamine:[{id:"oak",name:"Oak",hex:"#c9a36a"},
            {id:"walnut",name:"Walnut",hex:"#6e4a32"}],
  veneer:[{id:"oakveneer",name:"Oak Veneer",hex:"#9a7f5e"},
          {id:"walnutveneer",name:"Walnut Veneer",hex:"#79553f"}]
};
var BASES=[{id:"kraft",name:"Kraft",hex:"#c8a878"},
  {id:"dgrey",name:"Dark Grey",hex:"#81807C",alb:"#4E4E4C"},
  {id:"red",name:"Red",hex:"#9F3B3D",alb:"#4F2220"},
  {id:"blue",name:"Blue",hex:"#1A217D",alb:"#181C4D"}];
var SIBLING={
  "roll-single-eu":"roll-queen-eu","roll-queen-eu":"roll-single-eu",
  "roll-single-uk":"roll-king-uk","roll-king-uk":"roll-single-uk",
  "roll-single-au":"roll-queen-au","roll-queen-au":"roll-single-au",
  "roll-twin-xl-us":"roll-queen-us","roll-queen-us":"roll-twin-xl-us"
};

var state={size:CFG.size||"small",finishType:"melamine",finishId:"oak",baseColour:"kraft",led:false,view:"closed"};
function finishList(){return FINISH[state.finishType];}
function activeFinish(){return finishList().find(function(f){return f.id===state.finishId;})||finishList()[0];}
function activeBase(){return BASES.find(function(b){return b.id===state.baseColour;})||BASES[0];}

/* ---------- variant index built from the live product ---------- */
var P=CFG.product, VIDX={}, IDX={f:0,b:1,l:2};
function key(f,b,l){return f+"|"+b+"|"+(l?"LED":"No LED");}
function optVals(v){ return v.options && v.options.length ? v.options : [v.option1,v.option2,v.option3]; }
(function(){
  // Detect which option slot holds which axis by matching known value names,
  // so renaming an option in Shopify cannot break the lookup.
  var FN={},BN={},LN={"LED":1,"No LED":1};
  ["paint","melamine","veneer"].forEach(function(t){FINISH[t].forEach(function(x){FN[x.name]=1;});});
  BASES.forEach(function(b){BN[b.name]=1;});
  var hit={f:{},b:{},l:{}};
  P.variants.forEach(function(v){
    optVals(v).forEach(function(val,i){
      if(FN[val]) hit.f[i]=(hit.f[i]||0)+1;
      if(BN[val]) hit.b[i]=(hit.b[i]||0)+1;
      if(LN[val]) hit.l[i]=(hit.l[i]||0)+1;
    });
  });
  function best(o,fallback){ var k=null; for(var i in o){ if(k===null||o[i]>o[k]) k=i; }
    return k===null?fallback:parseInt(k,10); }
  IDX={f:best(hit.f,0), b:best(hit.b,1), l:best(hit.l,2)};
  P.variants.forEach(function(v){
    var o=optVals(v);
    VIDX[key(o[IDX.f],o[IDX.b],o[IDX.l]==="LED")]=v;
  });
  if(!Object.keys(VIDX).length) console.warn("[ROLL] variant index empty — check option values");
})();
function currentVariant(){return VIDX[key(activeFinish().name,activeBase().name,state.led)];}
function money(cents){
  try{return new Intl.NumberFormat(document.documentElement.lang||"en",
    {style:"currency",currency:CFG.currency,maximumFractionDigits:0}).format(cents/100);}
  catch(e){return (cents/100).toFixed(0)+" "+CFG.currency;}
}
function deltaFrom(base,v){return v?v.price-base:0;}
function cheapest(){var m=null;P.variants.forEach(function(v){if(!m||v.price<m.price)m=v;});return m;}

/* ---------- modal shell ---------- */
var STYLE='#roll3d-ov{position:fixed;inset:0;z-index:99999;background:rgba(24,22,19,.55);display:none}'+
'#roll3d-ov.on{display:block}'+
'#roll3d-panel{position:absolute;inset:2vh 2vw;background:#efece6;border-radius:14px;overflow:hidden;display:grid;grid-template-columns:1fr 380px}'+
'@media(max-width:900px){#roll3d-panel{grid-template-columns:1fr;grid-template-rows:1fr auto;inset:0;border-radius:0}}'+
'#roll3d-stage{position:relative;min-height:200px}#roll3d-stage canvas{display:block;width:100%;height:100%}'+
'#roll3d-side{background:#fff;padding:20px;overflow:auto;font:14px/1.45 system-ui,-apple-system,sans-serif;color:#2b2822}'+
'#roll3d-close{position:absolute;top:12px;right:12px;z-index:5;border:none;background:#fff;border-radius:999px;width:34px;height:34px;font-size:18px;cursor:pointer}'+
'.r3-lab{font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#2b2822;font-weight:600;margin:18px 0 9px}'+
'.r3-row{display:flex;flex-wrap:wrap;gap:7px}'+
'.r3-sw{display:flex;align-items:center;gap:7px;border:1px solid #ddd8cd;background:#fff;border-radius:9px;padding:7px 10px;cursor:pointer;font:inherit}'+
'.r3-sw[aria-pressed="true"]{border-color:#2b2822;box-shadow:inset 0 0 0 1px #2b2822}'+
'.r3-dot{width:15px;height:15px;border-radius:4px;border:1px solid rgba(0,0,0,.15);display:inline-block}'+
'.r3-tag{font-size:11px;color:#8a8172}'+
'.r3-seg{display:flex;gap:6px;margin-bottom:10px}'+'#roll3d-stage .r3-seg{position:absolute;bottom:16px;left:50%;transform:translateX(-50%);width:280px;z-index:6;margin:0;background:rgba(255,255,255,.85);padding:5px;border-radius:12px;backdrop-filter:blur(6px);box-shadow:0 2px 10px rgba(0,0,0,.12)}'+'#roll3d-stage canvas{position:relative;z-index:1}'+
'.r3-seg button{flex:1;border:1px solid #ddd8cd;background:#fff;border-radius:9px;padding:8px;cursor:pointer;font:inherit}'+
'.r3-seg button[aria-pressed="true"]{border-color:#2b2822;font-weight:600}'+
'.r3-li{display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #f0ece4}'+
'.r3-tot{font-weight:700;border-bottom:none;padding-top:10px}'+
'.r3-cta{width:100%;margin-top:12px;padding:14px;border:none;border-radius:10px;background:#2b2822;color:#fff;font:inherit;font-weight:600;cursor:pointer}'+
'.r3-cta[disabled]{opacity:.5;cursor:default}'+
'.r3-switch{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;border:1px solid #ddd8cd;border-radius:9px;padding:11px 12px;background:#fff;cursor:pointer;font:inherit}'+'.r3-switch[aria-checked="true"]{border-color:#2b2822}'+'.r3-switch .r3-swtxt{display:flex;flex-direction:column;align-items:flex-start;gap:2px}'+'.r3-track{position:relative;flex:none;width:42px;height:24px;border-radius:999px;background:#d8d3c8;transition:.18s}'+'.r3-switch[aria-checked="true"] .r3-track{background:#2b2822}'+'.r3-knob{position:absolute;top:3px;left:3px;width:18px;height:18px;border-radius:50%;background:#fff;transition:.18s}'+'.r3-switch[aria-checked="true"] .r3-knob{left:21px}'+'.r3-sku{margin-top:8px;font:11px ui-monospace,monospace;color:#8a8172;text-align:center}'+
'.r3-ship{font-size:13px;color:#3a3730;margin-bottom:4px}'+
'.r3-note{font-size:11px;color:#8a8172;margin-top:6px}'+
'.r3-msg{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);font:13px system-ui;color:#6b6255}';

var ov,panel,stage,side,msg,booted=false;
function buildShell(){
  var st=document.createElement("style"); st.textContent=STYLE; document.head.appendChild(st);
  ov=document.createElement("div"); ov.id="roll3d-ov";
  ov.innerHTML='<div id="roll3d-panel">'+
    '<div id="roll3d-stage"><button id="roll3d-close" aria-label="Close">&times;</button>'+
    '<div class="r3-msg" id="roll3d-msg">Loading 3D model…</div>'+
    '<div class="r3-seg">'+
      '<button id="r3Closed" aria-pressed="true">Closed</button>'+
      '<button id="r3Open" aria-pressed="false">Open</button></div></div>'+
    '<div id="roll3d-side"></div></div>';
  document.body.appendChild(ov);
  panel=ov.querySelector("#roll3d-panel"); stage=ov.querySelector("#roll3d-stage");
  side=ov.querySelector("#roll3d-side"); msg=ov.querySelector("#roll3d-msg");
  ov.querySelector("#roll3d-close").onclick=close;
  ov.addEventListener("click",function(e){if(e.target===ov)close();});
  document.addEventListener("keydown",function(e){if(e.key==="Escape"&&ov.classList.contains("on"))close();});
}
function open(){ if(!ov)buildShell(); ov.classList.add("on"); document.body.style.overflow="hidden";
  readFromForm();
  if(!booted){ booted=true; loadThree(); }
  else { syncSize(); paint(); applyAll(); fit(); if(window.__R3&&__R3.resize)__R3.resize(); render(); } }
function close(){ ov.classList.remove("on"); document.body.style.overflow=""; writeToForm(); }

/* ---------- product-form sync ---------- */
function forms(){
  return Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
}
function mainForm(){
  var fs=forms(), best=null;
  fs.forEach(function(f){
    if(!f.querySelector('[name="id"]')) return;
    // prefer a form that is visible and inside the main product area
    var vis=f.offsetParent!==null;
    var score=(vis?2:0)+(f.closest('[id*="MainProduct"],[id*="main-product"],main,[role="main"]')?1:0);
    if(!best||score>best.s) best={f:f,s:score};
  });
  return best?best.f:(fs[0]||null);
}
function variantById(id){
  for(var i=0;i<P.variants.length;i++) if(P.variants[i].id===id) return P.variants[i];
  return null;
}
function selectedVariant(){
  // 1) URL is the theme's source of truth on OS2.0
  var q=new URLSearchParams(location.search).get("variant");
  var v=q?variantById(parseInt(q,10)):null;
  if(v) return v;
  // 2) the form's hidden id
  var f=mainForm();
  if(f){ var el=f.querySelector('[name="id"]');
    if(el){ v=variantById(parseInt(el.value,10)); if(v) return v; } }
  // 3) read whatever option controls are checked/selected
  if(f){
    var picked=[];
    f.querySelectorAll('input[type="radio"]:checked,select').forEach(function(el){
      if(el.tagName==="SELECT"){ if(el.value) picked.push(el.value); }
      else picked.push(el.value);
    });
    if(picked.length){
      for(var i=0;i<P.variants.length;i++){
        var o=optVals(P.variants[i]);
        if(o.every(function(val){return picked.indexOf(val)>-1;})) return P.variants[i];
      }
    }
  }
  return null;
}
function readFromForm(){
  var v=selectedVariant(); if(!v) return;
  var o=optVals(v);
  var fn=o[IDX.f], bn=o[IDX.b], ln=o[IDX.l];
  ["paint","melamine","veneer"].forEach(function(t){
    FINISH[t].forEach(function(x){ if(x.name===fn){state.finishType=t;state.finishId=x.id;} });
  });
  BASES.forEach(function(b){ if(b.name===bn) state.baseColour=b.id; });
  state.led=(ln==="LED");
}
/* Drive the theme's own controls so its price, gallery and hidden id all follow.
   Searched document-wide: OS2.0 themes often render variant pickers outside the
   <form> and link them back with a form="" attribute. */
function scope(){
  return document.querySelector('[id*="MainProduct"],[id*="main-product"],main,[role="main"]')||document;
}
function esc(v){ return (window.CSS&&CSS.escape)?CSS.escape(v):v.replace(/"/g,'\\"'); }
function fire(el){
  if(!el) return false;
  el.click();
  return true;
}
function pickOptionValue(val){
  var root=scope(), e=esc(val);

  // 1. Broadcast swatch label
  var lab=root.querySelector('label[data-swatch="'+e+'"]');
  if(lab){
    var inp=lab.htmlFor?document.getElementById(lab.htmlFor):null;
    if(inp&&inp.checked) return true;
    return fire(lab);
  }
  // 2. plain radio by value
  var r=root.querySelector('input[type="radio"][value="'+e+'"]');
  if(r){ if(r.checked) return true;
    var l2=r.id?root.querySelector('label[for="'+esc(r.id)+'"]'):null;
    if(l2) return fire(l2);
    r.click(); if(!r.checked){ r.checked=true; r.dispatchEvent(new Event("change",{bubbles:true})); }
    return true; }
  // 3. select
  var sels=root.querySelectorAll('select');
  for(var i=0;i<sels.length;i++){
    if(sels[i].querySelector('option[value="'+e+'"]')){
      if(sels[i].value!==val){ sels[i].value=val;
        sels[i].dispatchEvent(new Event("change",{bubbles:true})); }
      return true; }
  }
  // 4. data attributes
  var d=root.querySelector('[data-value="'+e+'"],[data-option-value="'+e+'"],[data-variant-option-value="'+e+'"]');
  if(d) return fire(d);
  // 5. visible text match
  var c=root.querySelectorAll('label,button,li,a');
  for(var j=0;j<c.length;j++){
    if((c[j].textContent||"").trim()===val) return fire(c[j]);
  }
  return false;
}
function writeToForm(){
  var v=currentVariant(); if(!v) return;
  var vals=[activeFinish().name,activeBase().name,state.led?"LED":"No LED"];
  var missed=[];
  vals.forEach(function(val){ if(!pickOptionValue(val)) missed.push(val); });
  // backstop: write the id into every cart form
  forms().forEach(function(fm){
    var el=fm.querySelector('[name="id"]');
    if(el) el.value=v.id;
  });
  try{ var u=new URL(location.href); u.searchParams.set("variant",v.id);
       history.replaceState({},"",u); }catch(e){}
  if(missed.length) console.warn("[ROLL] theme controls not matched for:",missed.join(", "),
    "\u2014 variant id written directly");
  document.dispatchEvent(new CustomEvent("roll:variant",{detail:{variant:v}}));
}

/* ---------- side panel ---------- */
function swatch(item,sel,extra){
  var b=document.createElement("button"); b.className="r3-sw"; b.setAttribute("aria-pressed",sel);
  b.innerHTML='<span class="r3-dot" style="background:'+(item.sw||item.hex)+'"></span>'+item.name+
    (extra?'<span class="r3-tag">'+extra+'</span>':'');
  return b;
}
function paint(){
  var base=cheapest(), cur=currentVariant();
  var h='<div class="r3-ship">Shipping to <b>'+(CFG.countryName||CFG.country)+'</b> · '+CFG.currency+'</div>'+
        '<div class="r3-lab">Size</div><div class="r3-seg" id="r3Size"></div>'+
        '<div class="r3-lab">Cabinet finish</div><div class="r3-row" id="r3Fin"></div>'+
        '<div class="r3-lab">Premium oiled natural veneer finish</div><div class="r3-row" id="r3Ven"></div>'+
        '<div class="r3-lab">Base colour</div><div class="r3-row" id="r3Base"></div>'+
        '<div class="r3-lab">Add-ons</div><div class="r3-row" id="r3Led"></div>'+
        '<div id="r3Sum" style="margin-top:18px"></div>';
  side.innerHTML=h;

  var sz=document.getElementById("r3Size");
  [["small",CFG.sizeLabels&&CFG.sizeLabels.small||"Small"],["big",CFG.sizeLabels&&CFG.sizeLabels.big||"Large"]]
    .forEach(function(pair){
      var b=document.createElement("button"); b.textContent=pair[1];
      b.setAttribute("aria-pressed",state.size===pair[0]);
      b.onclick=function(){ if(state.size===pair[0])return; gotoSibling(); };
      sz.appendChild(b);
    });

  var fr=document.getElementById("r3Fin");
  FINISH.paint.map(function(f){return[f,"paint"];})
    .concat(FINISH.melamine.map(function(f){return[f,"melamine"];}))
    .forEach(function(p){
      var el=swatch(p[0],state.finishType===p[1]&&state.finishId===p[0].id,"incl.");
      el.onclick=function(){state.finishType=p[1];state.finishId=p[0].id;paint();applyFinish();};
      fr.appendChild(el);
    });
  var vr=document.getElementById("r3Ven");
  FINISH.veneer.forEach(function(f){
    var probe=VIDX[key(f.name,"Kraft",false)], d=probe?probe.price-base.price:0;
    var el=swatch(f,state.finishType==="veneer"&&state.finishId===f.id,d>0?"+"+money(d):"");
    el.onclick=function(){state.finishType="veneer";state.finishId=f.id;paint();applyFinish();};
    vr.appendChild(el);
  });
  var br=document.getElementById("r3Base");
  BASES.forEach(function(b){
    var probe=VIDX[key(activeFinish().name,b.name,state.led)];
    var ref=VIDX[key(activeFinish().name,"Kraft",state.led)];
    var d=(probe&&ref)?probe.price-ref.price:0;
    var el=swatch(b,state.baseColour===b.id,d>0?"+"+money(d):"incl.");
    el.onclick=function(){state.baseColour=b.id;paint();applyBase();};
    br.appendChild(el);
  });
  var lr=document.getElementById("r3Led");
  var on=VIDX[key(activeFinish().name,activeBase().name,true)],
      off=VIDX[key(activeFinish().name,activeBase().name,false)];
  var dl=(on&&off)?on.price-off.price:0;
  var sw=document.createElement("button");
  sw.type="button"; sw.className="r3-switch"; sw.setAttribute("role","switch");
  sw.setAttribute("aria-checked",state.led?"true":"false");
  sw.innerHTML='<span class="r3-swtxt"><b>Add LED lights</b>'+
    (dl>0?'<span class="r3-tag">+'+money(dl)+'</span>':'')+'</span>'+
    '<span class="r3-track"><span class="r3-knob"></span></span>';
  sw.onclick=function(){state.led=!state.led;paint();applyLed();};
  lr.appendChild(sw);

  var v=cur||off, sum=document.getElementById("r3Sum");
  sum.innerHTML='<div class="r3-li r3-tot"><b>Total</b><span>'+(v?money(v.price):"—")+'</span></div>'+
    '<button class="r3-cta" id="r3Cta"'+(v?"":" disabled")+'>Add to cart</button>'+
    '<div class="r3-sku">'+(v&&v.sku?v.sku:"")+'</div>';
  if(v){ document.getElementById("r3Cta").onclick=function(){addToCart(this,v);}; }
  else { sum.insertAdjacentHTML("beforeend",
    '<div class="r3-note">This combination isn\'t available on this product.</div>'); }
}
function gotoSibling(){
  var sib=SIBLING[CFG.handle]; if(!sib) return;
  var q="?finish="+encodeURIComponent(activeFinish().name)+
        "&base="+encodeURIComponent(activeBase().name)+
        "&led="+(state.led?"1":"0")+"&open3d=1";
  window.location.href="/products/"+sib+q;
}
function addToCart(btn,v){
  btn.disabled=true; btn.textContent="Adding…";
  fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},
    body:JSON.stringify({items:[{id:v.id,quantity:1}]})})
  .then(function(r){ if(!r.ok) throw new Error("cart"); return r.json(); })
  .then(function(){ btn.textContent="Added ✓";
    document.dispatchEvent(new CustomEvent("roll:added",{detail:{variant:v}}));
    setTimeout(function(){ window.location.href="/cart"; },600); })
  .catch(function(){ btn.disabled=false; btn.textContent="Couldn't add — try again"; });
}

/* ---------- deep link from the sibling product ---------- */
(function(){
  var q=new URLSearchParams(location.search);
  if(!q.get("open3d")) return;
  var fn=q.get("finish"), bn=q.get("base");
  ["paint","melamine","veneer"].forEach(function(t){
    FINISH[t].forEach(function(x){ if(x.name===fn){state.finishType=t;state.finishId=x.id;} }); });
  BASES.forEach(function(b){ if(b.name===bn) state.baseColour=b.id; });
  state.led=(q.get("led")==="1");
  document.addEventListener("DOMContentLoaded",function(){ setTimeout(open,60); });
})();

/* ---------- LOOK: edit these numbers to change the lighting ---------- */
var LOOK={
  bloomStrength : 0.35,  // overall glow amount. lower = less bloom
  bloomRadius   : 0.55,  // how far the glow spreads
  bloomThreshold: 2.30,  // brightness a pixel must exceed to bloom.
                         // RAISE this to stop pale surfaces hazing
  exposure      : 0.95,  // ACES tone-mapping exposure. lower = darker overall
  ambient       : 0.60,  // fill light
  key           : 0.80,  // directional (shadow-casting) light
  ledGlow       : 8.00   // LED emissive intensity when switched on
};

/* ---------- three.js boot ---------- */
var THREE,T,renderer,scene,camera,controls,composer,dirLight,bloom,outPass,ambient,CL=[],OL=[],M={},OILED={closed:{},open:{}};
var closedG,openG,closedSm,closedBg,openSm,openBg,needsRender=true,pending=4;
function loadThree(){
  var s=document.createElement("script"); s.src=CFG.threeUrl;
  s.onload=init; s.onerror=function(){msg.textContent="Could not load 3D engine.";};
  document.head.appendChild(s);
}
function render(){needsRender=true;}
function hexArr(h){h=h.replace("#","");return[parseInt(h.substr(0,2),16)/255,parseInt(h.substr(2,2),16)/255,parseInt(h.substr(4,2),16)/255];}
function activeClosed(){return state.size==="big"?closedBg:closedSm;}
function activeOpen(){return state.size==="big"?openBg:openSm;}

function init(){
  T=window.__T; THREE=T.THREE;
  renderer=new THREE.WebGLRenderer({antialias:true});
  renderer.setPixelRatio(Math.min(window.devicePixelRatio,2));
  renderer.shadowMap.enabled=true; renderer.shadowMap.type=THREE.PCFSoftShadowMap;
  stage.appendChild(renderer.domElement);
  scene=new THREE.Scene(); scene.background=new THREE.Color("#efece6");
  var pmrem=new THREE.PMREMGenerator(renderer);
  scene.environment=pmrem.fromScene(new T.RoomEnvironment(),0.04).texture;
  camera=new THREE.PerspectiveCamera(35,1,0.1,10000);
  ambient=new THREE.AmbientLight(0xffffff,LOOK.ambient); scene.add(ambient);
  dirLight=new THREE.DirectionalLight(0xffffff,LOOK.key);
  dirLight.castShadow=true; dirLight.shadow.mapSize.set(2048,2048); dirLight.shadow.bias=-0.0005;
  scene.add(dirLight);
  var sp=new THREE.Mesh(new THREE.PlaneGeometry(20,20),new THREE.ShadowMaterial({opacity:0.08}));
  sp.rotation.x=-Math.PI/2; sp.receiveShadow=true; scene.add(sp);
  controls=new T.OrbitControls(camera,renderer.domElement);
  controls.enableDamping=true; controls.dampingFactor=0.05; controls.enablePan=false;
  controls.maxPolarAngle=Math.PI/2-0.02;
  composer=new T.EffectComposer(renderer);
  composer.addPass(new T.RenderPass(scene,camera));
  bloom=new T.UnrealBloomPass(new THREE.Vector2(1,1),LOOK.bloomStrength,LOOK.bloomRadius,LOOK.bloomThreshold);
  composer.addPass(bloom);
  outPass=new T.OutputPass(); outPass.toneMapping=THREE.ACESFilmicToneMapping;
  outPass.toneMappingExposure=LOOK.exposure;
  composer.addPass(outPass);

  closedG=new THREE.Group(); openG=new THREE.Group(); scene.add(closedG); scene.add(openG); openG.visible=false;
  closedSm=new THREE.Group(); closedBg=new THREE.Group(); closedG.add(closedSm); closedG.add(closedBg);
  openSm=new THREE.Group(); openBg=new THREE.Group(); openG.add(openSm); openG.add(openBg);

  var tl=new THREE.TextureLoader(); tl.setCrossOrigin("anonymous");
  function tex(u,srgb){var t=tl.load(u,render); t.flipY=false;
    t.colorSpace=srgb?THREE.SRGBColorSpace:THREE.NoColorSpace; return t;}
  function rep(u,r,lin){var t=tex(u,!lin); t.wrapS=t.wrapT=THREE.RepeatWrapping; t.repeat.set(r,r); t.needsUpdate=true; return t;}
  OILED.closed.oakveneer={b:rep(A.oakB,2.30),n:rep(A.oakN,2.30,1),m:rep(A.oakR,2.30,1),tiled:true};
  OILED.open.oakveneer  ={b:rep(A.oakB,1.93),n:rep(A.oakN,1.93,1),m:rep(A.oakR,1.93,1),tiled:true};
  OILED.closed.walnutveneer={b:rep(A.walB,2.30),n:rep(A.walN,2.30,1),m:rep(A.walR,2.30,1),tiled:true};
  OILED.open.walnutveneer  ={b:rep(A.walB,1.93),n:rep(A.walN,1.93,1),m:rep(A.walR,1.93,1),tiled:true};
  M.cWalTex=tex(A.melClosed,1); M.oWalTex=tex(A.melOpen,1); M.oCardNeu=tex(A.card,1);

  var loader=new T.GLTFLoader();
  function done(){ if(--pending<=0) msg.style.display="none"; }
  function fail(t){ return function(){ msg.textContent="Model failed to load ("+t+")"; }; }
  function prep(o){o.castShadow=true;o.receiveShadow=false;if(o.material)o.material.envMapIntensity=1.0;}

  function loadClosed(url,group,tag){
    var e={group:group}; CL.push(e);
    loader.load(url,function(g){
      g.scene.traverse(function(o){ if(!o.isMesh)return; prep(o);
        var nm=(o.name||"").toLowerCase();
        if(nm.indexOf("glowfloor")>=0){o.castShadow=false;o.material.toneMapped=false;e.glow=o;o.visible=false;}
        else if(nm.indexOf("wood")>=0){e.wood=o.material;e.oak=o.material.map;e.kind="closed";
          e.oNrm=o.material.normalMap;e.oMR=o.material.roughnessMap;
          e.oNS=o.material.normalScale?o.material.normalScale.clone():null;
          e.oRough=o.material.roughness;e.oEnv=o.material.envMapIntensity;}
        else if(nm.indexOf("light")>=0){e.led=o.material;o.material.emissive=new THREE.Color("#ffeedd");o.material.emissiveIntensity=0;}
      });
      group.add(g.scene); applyAll(); if(state.view==="closed")fit(); render(); done();
    },undefined,fail(tag));
  }
  function loadOpen(url,group,tag){
    var e={group:group}; OL.push(e);
    loader.load(url,function(g){
      g.scene.traverse(function(o){ if(!o.isMesh)return; prep(o);
        var nm=((o.material&&o.material.name)||o.name||"").toLowerCase();
        if(nm.indexOf("wood")>=0){e.wood=o.material;e.oak=o.material.map;e.kind="open";
          e.oNrm=o.material.normalMap;e.oMR=o.material.roughnessMap;
          e.oNS=o.material.normalScale?o.material.normalScale.clone():null;
          e.oRough=o.material.roughness;e.oEnv=o.material.envMapIntensity;}
        else if(nm.indexOf("light")>=0){e.led=o.material;o.material.emissive=new THREE.Color("#ffeedd");o.material.emissiveIntensity=0;}
        else if(nm.indexOf("cardboard")>=0){e.card=o.material;e.cardTex=o.material.map;}
        else if(nm.indexOf("mattress")>=0){o.material.color.setRGB(1,1,1); if(o.material.normalScale)o.material.normalScale.multiplyScalar(1.6);}
      });
      group.add(g.scene); if(state.view==="open")fit(); applyAll(); render(); done();
    },undefined,fail(tag));
  }
  loadClosed(A.closed100,closedSm,"closed-100"); loadClosed(A.closed150,closedBg,"closed-150");
  loadOpen(A.open100,openSm,"open-100");         loadOpen(A.open150,openBg,"open-150");

  document.getElementById("r3Closed").onclick=function(){setView("closed");};
  document.getElementById("r3Open").onclick=function(){setView("open");};
  window.addEventListener("resize",resize);
  if(window.ResizeObserver) new ResizeObserver(resize).observe(stage);
  controls.addEventListener("change",render);
  (function tick(){ requestAnimationFrame(tick);
    var moved=controls.update(); if(needsRender||moved){needsRender=false;composer.render();} })();
  window.__R3={resize:resize,LOOK:LOOK,
    tune:function(o){
      Object.keys(o||{}).forEach(function(k){ if(k in LOOK) LOOK[k]=o[k]; });
      if(bloom){ bloom.strength=LOOK.bloomStrength; bloom.radius=LOOK.bloomRadius;
                 bloom.threshold=LOOK.bloomThreshold; }
      if(outPass) outPass.toneMappingExposure=LOOK.exposure;
      if(ambient) ambient.intensity=LOOK.ambient;
      if(dirLight) dirLight.intensity=LOOK.key;
      applyLed(); render();
      console.log("[ROLL] LOOK =",JSON.stringify(LOOK,null,1));
      return LOOK;
    }};
  syncSize(); paint(); resize(); fit();
}
function syncSize(){ var big=state.size==="big";
  closedSm.visible=!big; closedBg.visible=big; openSm.visible=!big; openBg.visible=big; }
function setView(v){ state.view=v;
  closedG.visible=(v==="closed"); openG.visible=(v==="open");
  document.getElementById("r3Closed").setAttribute("aria-pressed",v==="closed");
  document.getElementById("r3Open").setAttribute("aria-pressed",v==="open");
  applyLed(); fit(); render(); }
function fit(){
  if(!camera) return;
  var g=state.view==="open"?activeOpen():activeClosed();
  var box=new THREE.Box3().setFromObject(g); if(box.isEmpty())return;
  var s=box.getSize(new THREE.Vector3()), maxDim=Math.max(s.x,s.y,s.z);
  var zf=(state.view==="open")?1.0:0.55;
  camera.position.set(s.x*1.5*zf,s.y*2.5*zf,s.z*2.0*zf);
  controls.target.set(0,s.y/2,0);
  controls.maxDistance=maxDim*4; controls.minDistance=maxDim*(state.view==="open"?0.8:0.45);
  dirLight.position.set(maxDim,maxDim*1.5,maxDim); controls.update();
}
function resize(){ if(!renderer)return;
  var w=stage.clientWidth,h=stage.clientHeight; if(!w||!h)return;
  renderer.setSize(w,h,false); composer.setSize(w,h);
  camera.aspect=w/h; camera.updateProjectionMatrix(); render(); }
function applyFinish(){
  if(!CL.length&&!OL.length) return;
  var f=activeFinish();
  var rows=CL.map(function(e){return[e,M.cWalTex];});
  OL.forEach(function(e){rows.push([e,M.oWalTex]);});
  rows.forEach(function(row){
    var e=row[0],wal=row[1],mat=e.wood; if(!mat)return;
    if(state.finishType==="veneer"){
      var set=(OILED[e.kind]||OILED.closed)[state.finishId];
      set.b.flipY=e.oak?e.oak.flipY:false; set.n.flipY=set.b.flipY; set.m.flipY=set.b.flipY;
      mat.map=set.b; mat.normalMap=set.n; mat.roughnessMap=set.m; mat.metalnessMap=null;
      if(mat.normalScale)mat.normalScale.set(1,1);
      mat.roughness=1.0; mat.metalness=0.0; mat.envMapIntensity=1.25; mat.color.setRGB(1,1,1);
    } else if(state.finishType==="melamine"){
      mat.map=(state.finishId==="walnut")?(wal||e.oak):e.oak;
      mat.normalMap=e.oNrm||null; mat.roughnessMap=e.oMR||null; mat.metalnessMap=e.oMR||null;
      if(mat.normalScale&&e.oNS)mat.normalScale.copy(e.oNS);
      mat.roughness=(e.oRough!==undefined?e.oRough:1); mat.envMapIntensity=(e.oEnv!==undefined?e.oEnv:1);
      mat.color.setRGB(1,1,1);
    } else {
      mat.map=null; mat.normalMap=e.oNrm||null; mat.roughnessMap=e.oMR||null; mat.metalnessMap=e.oMR||null;
      if(mat.normalScale&&e.oNS)mat.normalScale.copy(e.oNS);
      mat.roughness=(e.oRough!==undefined?e.oRough:1); mat.envMapIntensity=(e.oEnv!==undefined?e.oEnv:1);
      var c=hexArr(f.hex); mat.color.setRGB(c[0],c[1],c[2]);
    }
    mat.needsUpdate=true;
  });
  render();
}
function applyLed(){
  var on=state.led;
  CL.map(function(e){return e.led;}).concat(OL.map(function(e){return e.led;})).forEach(function(m){
    if(!m)return; m.emissiveIntensity=on?8:0;
    m.color.setRGB(on?1:0.15,on?1:0.15,on?1:0.15); m.needsUpdate=true; });
  CL.forEach(function(e){ if(e.glow) e.glow.visible=on&&state.view==="closed"&&activeClosed()===e.group; });
  render();
}
function applyBase(){
  var c=activeBase();
  OL.forEach(function(e){ if(!e.card)return;
    if(c.id==="kraft"){e.card.map=e.cardTex;e.card.color.setRGB(0.87,0.86,0.84);e.card.envMapIntensity=1.0;}
    else{e.card.map=M.oCardNeu||e.cardTex;var a=hexArr(c.alb||c.hex);
      e.card.color.setRGB(a[0],a[1],a[2]);e.card.envMapIntensity=0.3;}
    e.card.needsUpdate=true; });
  render();
}
function applyAll(){applyFinish();applyLed();applyBase();}

/* ---------- turn the theme's LED option into a switch ---------- */
function ledInputs(){
  var d=document;
  var on=d.querySelector('input[type="radio"][value="LED"]');
  var off=d.querySelector('input[type="radio"][value="No LED"]');
  return (on&&off)?{on:on,off:off}:null;
}
function ledIsOn(){
  var i=ledInputs(); if(i) return i.on.checked;
  var v=selectedVariant(); return v?optVals(v)[IDX.l]==="LED":false;
}
/* smallest element containing both radios = the option group, no class guessing */
function groupOf(a,b){
  var p=a.parentElement;
  while(p&&p!==document.body){ if(p.contains(b)) return p; p=p.parentElement; }
  return null;
}
function ledSurcharge(){
  try{
    var v=selectedVariant()||cheapest(), o=optVals(v);
    var a=VIDX[key(o[IDX.f],o[IDX.b],true)], b=VIDX[key(o[IDX.f],o[IDX.b],false)];
    if(a&&b&&a.price>b.price) return " (+"+money(a.price-b.price)+")";
  }catch(e){}
  return "";
}
function injectLedStyle(){
  if(document.getElementById("roll-led-css")) return;
  var st=document.createElement("style"); st.id="roll-led-css";
  st.textContent='#roll-led-switch{display:flex;align-items:center;justify-content:space-between;gap:14px;'+
    'width:100%;border:0;border-radius:0;padding:10px 0;background:transparent;'+
    'color:inherit;font:inherit;cursor:pointer;opacity:.7;margin:6px 0;text-align:left;'+
    '-webkit-appearance:none;appearance:none;box-shadow:none}'+
    '#roll-led-switch:focus{outline:none}'+
    '#roll-led-switch:focus-visible{outline:2px solid currentColor;outline-offset:3px}'+
    '#roll-led-switch[aria-checked="true"]{opacity:1}'+
    '#roll-led-switch .rl-track{position:relative;flex:none;width:44px;height:25px;border-radius:999px;'+
    'background:rgba(128,128,128,.35);transition:.18s}'+
    '#roll-led-switch[aria-checked="true"] .rl-track{background:currentColor}'+
    '#roll-led-switch .rl-knob{position:absolute;top:3px;left:3px;width:19px;height:19px;border-radius:50%;'+
    'background:#fff;transition:.18s}'+
    '#roll-led-switch[aria-checked="true"] .rl-knob{left:22px}'+
    '.roll-led-hidden{display:none !important}';
  document.head.appendChild(st);
}
function buildLedSwitch(){
  var ex=document.getElementById("roll-led-switch");
  var i=ledInputs();
  if(!i){ return false; }
  var group=groupOf(i.on,i.off);
  if(!group){ console.warn("[ROLL] LED option group not found"); return false; }

  // hide the group, plus a neighbouring title element if it labels this option
  group.classList.add("roll-led-hidden");
  var prev=group.previousElementSibling;
  if(prev&&/led/i.test((prev.textContent||"").trim())&&(prev.textContent||"").trim().length<40)
    prev.classList.add("roll-led-hidden");
  var par=group.parentElement;
  if(par&&par!==document.body){
    var t=(par.textContent||"").replace(/\s+/g," ").trim();
    if(/^LED lighting/i.test(t)&&t.length<60) par.classList.add("roll-led-hidden");
  }

  if(ex){ ex.setAttribute("aria-checked",ledIsOn()?"true":"false");
          ex.querySelector(".rl-txt").textContent="Add LED lights"+ledSurcharge();
          return true; }

  injectLedStyle();
  var btn=document.createElement("button");
  btn.type="button"; btn.id="roll-led-switch"; btn.setAttribute("role","switch");
  btn.setAttribute("aria-checked",ledIsOn()?"true":"false");
  btn.innerHTML='<span class="rl-txt">Add LED lights'+ledSurcharge()+'</span>'+
                '<span class="rl-track"><span class="rl-knob"></span></span>';
  btn.addEventListener("click",function(){
    var want=btn.getAttribute("aria-checked")!=="true";
    pickOptionValue(want?"LED":"No LED");
    btn.setAttribute("aria-checked",want?"true":"false");
  });
  var host=group.classList.contains("roll-led-hidden")&&group.parentElement.classList.contains("roll-led-hidden")
    ? group.parentElement : group;
  host.parentNode.insertBefore(btn,host);
  console.log("[ROLL] LED switch installed");
  return true;
}
(function(){
  function sync(){
    var b=document.getElementById("roll-led-switch");
    if(b){ b.setAttribute("aria-checked",ledIsOn()?"true":"false");
           b.querySelector(".rl-txt").textContent="Add LED lights"+ledSurcharge(); }
  }
  function go(){
    if(!buildLedSwitch()){
      var n=0,t=setInterval(function(){ if(buildLedSwitch()||++n>24) clearInterval(t); },250);
    }
    var busy=false;
    function ensure(){
      if(busy) return;                       // never re-enter
      busy=true;
      try{ if(!document.getElementById("roll-led-switch")) buildLedSwitch(); else sync(); }
      finally{ setTimeout(function(){busy=false;},120); }
    }
    document.addEventListener("change",function(){ sync(); ensure(); },true);
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",go); else go();
})();

/* ---------- split veneer finishes onto their own row ---------- */
var VENEER_NAMES=["Oak Veneer","Walnut Veneer"];
function finishInputs(){
  var names=[];
  ["paint","melamine","veneer"].forEach(function(t){FINISH[t].forEach(function(x){names.push(x.name);});});
  var out=[];
  names.forEach(function(n){
    var e=(window.CSS&&CSS.escape)?CSS.escape(n):n;
    var i=document.querySelector('input[type="radio"][value="'+e+'"]');
    if(i) out.push({name:n,input:i});
  });
  return out;
}
function commonAncestor(nodes){
  if(!nodes.length) return null;
  var p=nodes[0].parentElement;
  while(p&&p!==document.body){
    var all=true;
    for(var i=1;i<nodes.length;i++){ if(!p.contains(nodes[i])){all=false;break;} }
    if(all) return p;
    p=p.parentElement;
  }
  return null;
}
/* the pieces belonging to one swatch: either a single wrapper, or input+label */
function swatchNodes(list,input){
  var n=input;
  while(n&&n.parentElement!==list) n=n.parentElement;
  if(n&&n!==input) return [n];
  var out=[input];
  if(input.id){
    var e=(window.CSS&&CSS.escape)?CSS.escape(input.id):input.id;
    var lab=list.querySelector('label[for="'+e+'"]');
    if(lab) out.push(lab);
  }
  return out;
}
function splitVeneerRow(){
  if(document.getElementById("roll-veneer-row")) return true;
  var fin=finishInputs();
  if(fin.length<3) return false;
  var vens=fin.filter(function(f){return VENEER_NAMES.indexOf(f.name)>-1;});
  if(!vens.length) return false;
  var list=commonAncestor(fin.map(function(f){return f.input;}));
  if(!list) return false;

  if(!document.getElementById("roll-veneer-css")){
    var st=document.createElement("style"); st.id="roll-veneer-css";
    st.textContent='#roll-veneer-head{font-size:12px;letter-spacing:.12em;text-transform:uppercase;'+
      'font-weight:600;opacity:.85;margin:14px 0 8px}';
    document.head.appendChild(st);
  }
  var head=document.createElement("div");
  head.id="roll-veneer-head";
  head.textContent="Premium oiled natural veneer finish";

  var row=document.createElement(list.tagName);
  row.id="roll-veneer-row";
  row.className=list.className;

  vens.forEach(function(v){
    swatchNodes(list,v.input).forEach(function(n){ row.appendChild(n); });
  });

  list.parentNode.insertBefore(head,list.nextSibling);
  head.parentNode.insertBefore(row,head.nextSibling);
  console.log("[ROLL] veneer row split");
  return true;
}
(function(){
  function go(){
    if(!splitVeneerRow()){
      var n=0,t=setInterval(function(){ if(splitVeneerRow()||++n>24) clearInterval(t); },250);
    }
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",go); else go();
})();

/* ---------- button ---------- */
document.addEventListener("click",function(e){
  var b=e.target.closest&&e.target.closest("#roll-3d-open,[data-roll-3d]");
  if(b){ e.preventDefault(); open(); }
});
})();
